<template>
    <div class="mdui-container mdui-text-left" id="main-content">
        <div class="mdui-row mdui-row-gapless">
            <div v-if="s_none" class="mdui-text-center">
                <h1>什么都没找到(T ^ T)</h1>
            </div>
            <div v-if="!s_none" class="mdui-col-xs-6 mdui-col-md-3"  v-for="item in items">
                <router-link :to="{name: 'wordLink', query:{sort: ($route.name === 'yysLink')? key:item.sort, uid: item.uid}}" class="chara">
                    <span class="face">
                        <img style="border-radius: 50%;" alt="face" :src="getPic(item.pid)">
                        <span class="frame">
                        </span>
                    </span>
                    <span class="name">CV: {{item.cv}}</span>
                </router-link>
            </div>
        </div>

    </div>
</template>

<script>
    import mdui from 'mdui'
    import axios from 'axios'

    export default {
        name: "Part",
        data(){
            return{
                key: 'yys',
                items: [],
                s_none: false,
            }
        },
        props:{
            host:{
                require: true,
                type: String,
            }
        },
        methods:{
            getData(){
                // console.log(this.$options.name);
                axios.get(this.host + 'get_list?sort='+this.key)
                    .then((response) =>{
                        let data = response.data.data;
                        // console.log(response.data.data);
                        this.items = this.items.concat(data);
                        this.items.reverse();
                        // console.log(this.items);
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getSearch(){
                axios.get(this.host + 'search?'+this.key)
                    .then((response) =>{
                        let data = response.data.data;
                        // console.log(response.data.data);
                        if(data!==null&&typeof(data) !== "undefined"){
                            this.items = this.items.concat(data);
                            // console.log(this.items);
                        }else{
                            this.s_none = true;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getTitle(e){
                this.key = e;
                if(e==="yys"){
                    return "阴阳师";
                }else{
                    return e+"式神";
                }
            },
            getPic(e){
                if(this.key==="yys"){
                    return 'https://img.endcloud.cn/face/'+e+'.png';
                }else{
                    let a = 'https://yys.res.netease.com/pc/zt/20161108171335/data/shishen/';
                    let b= 'https://cos.endcloud.cn/yys/shikigami_face/';
                    let c= 'https://pic-1253752881.file.myqcloud.com/yys/shikigami_face/';
                    return b+e+'.png';
                }
            },
        },
        beforeMount(){
            if(this.$route.name === "yysLink") {
                this.$emit("titleChanged", this.getTitle(this.$route.query.key).toUpperCase());
                this.getData();
            }else{
                this.key = this.$route.query.key.toUpperCase();
                this.$emit("titleChanged", '“'+this.key+'”'+'的搜索结果');
                this.getSearch();
            }
        },
    }
</script>

<style scoped>
    a{
        text-decoration: none;
    }

    .chara .face{
        display: block;
        margin: 0 auto;
        width: 120px;
        height: 120px;
        position: relative;
    }

    .chara .name{
        display: block;
        color: #000;
        font-size: 16px;
        line-height: 40px;
        text-align: center;
    }

    .chara .cv{
        display: block;
        color: #000;
        font-size: 14px;
        text-align: center;
    }

    .chara .frame{
        top: 0;
        left: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        background-image: url("/static/img/frame.png");
        background-repeat: no-repeat;
    }

</style>


// WEBPACK FOOTER //
// src/components/Part.vue